import React, { useMemo } from "react";
import { subYears, addYears, format, eachMonthOfInterval } from "date-fns";
import { useCalendarData, getStartAndEndOfYear, calendarViews, getIsPreviousMonthDisabled, getIsNextMonthDisabled } from "../../utils";
import { getCultureLocalizer } from '../../../../utils';
import CalendarIcon from "../../../../svg/CalendarIcon/CalendarIcon";
import { Chevron } from "../../../../svg";
import { chevronDirection } from "../../../../svg/Svg";

import { useReactAppState } from "../../../../../shared/containers/utils";

function Months() {
  const { t } = useReactAppState();
  const {
    currentDate,
    onTodaySelect,
    setCurrentDate,
    onDateSelect,
    setView,
    minDate,
    maxDate
  } = useCalendarData();
  const toYear = format(currentDate, 'y');
  const currentMonth = format(currentDate, 'MMM', { locale: getCultureLocalizer() });
  const startAndEndOfYear = getStartAndEndOfYear(currentDate);
  const monthsList = eachMonthOfInterval(startAndEndOfYear);

  const monthList = useMemo(() => {
    return (
      monthsList.map(month => {
        const formattedMonth = format(month, 'MMM', { locale: getCultureLocalizer() });

        return <button onClick={(e) => onDateSelect(e, month)} className={`mls-o-calendar__month ${currentMonth === formattedMonth ? "mls-o-calendar__month--current-month" : ""}`} key={formattedMonth}>{formattedMonth}</button>;
      })
    );
  }, [startAndEndOfYear]);

  const isDisabledPreviousMonth = useMemo(() => {
    return getIsPreviousMonthDisabled({ date: startAndEndOfYear.start, minDate, maxDate })
  }, [startAndEndOfYear, minDate, maxDate]);

  const isDisabledNextMonth = useMemo(() => {
    return getIsNextMonthDisabled({ date: startAndEndOfYear.end, minDate, maxDate })
  }, [startAndEndOfYear, minDate, maxDate]);

  return (
    <div className="mls-o-calendar__months-view">
      <div className="mls-o-calendar__header">
        <button type="button" className="mls-o-calendar__prev-month"
          disabled={isDisabledPreviousMonth}
          onClick={() => isDisabledPreviousMonth ? null : setCurrentDate(subYears(currentDate, 1))}>
          <Chevron direction={chevronDirection.left} />
        </button>
        <button type="button" onClick={() => setView(calendarViews.years)} className="mls-o-calendar__title">
          <CalendarIcon />
          <span className="mls-o-calendar__title-label">{toYear}</span>
        </button>
        <button type="button" className="mls-o-calendar__next-month"
          disabled={isDisabledNextMonth}
          onClick={() => isDisabledNextMonth ? null : setCurrentDate(addYears(currentDate, 1))}>
          <Chevron direction={chevronDirection.right} />
        </button>
      </div>

      <div className="mls-o-calendar__month-grid">
        {monthList}
      </div>
      <button onClick={onTodaySelect} className="mls-o-calendar__today">{t("today")}</button>
    </div>
  );
}

export default Months;
